"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityTableWithDetails = exports.EntityTable = void 0;
const DataTable_1 = require("@juvare/common-web-ui/DataTable");
const DialogHelper_1 = require("@juvare/common-web-ui/DialogHelper");
const ModalSlideout_1 = require("@juvare/common-web-ui/ModalSlideout");
const SnackbarHelper_1 = require("@juvare/common-web-ui/SnackbarHelper");
const StorageClient_1 = require("@juvare/platform-sdk-js/StorageClient");
const entity_import_1 = require("../../../ui/features/entity-import");
const hooks_1 = require("../../../ui/hooks");
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const dynamicColumns_1 = require("./dynamicColumns");
const entityExport_1 = require("./entityExport");
/**
 * Deprecated. Use DataTable from common-data-table-ui together with useEntityDataTable hook.
 *
 * @deprecated
 */
function EntityTable(props) {
    var _a, _b, _c, _d, _e, _f, _g;
    const appliedFilters = react_1.default.useRef();
    const appliedSort = react_1.default.useRef();
    const exportClient = (0, hooks_1.useExportClient)();
    const { data: dynamicDefinitions } = (0, dynamicColumns_1.useDynamicColumnDefinitions)(props.entity, !!props.dynamicColumns);
    const filters = react_1.default.useMemo(() => {
        var _a, _b, _c;
        const finalFilters = [];
        if ((_a = props.filterGroups) === null || _a === void 0 ? void 0 : _a.length) {
            const staticFilters = ((_b = props.filterGroups) !== null && _b !== void 0 ? _b : []);
            finalFilters.push(...staticFilters);
        }
        if (props.dynamicColumns) {
            finalFilters.push(...(0, dynamicColumns_1.mapDynamicColumnsToFilterGroups)(dynamicDefinitions, (_c = props.dynamicColumnsOptions) === null || _c === void 0 ? void 0 : _c.initialFilterValues));
        }
        return finalFilters.length ? finalFilters : undefined;
    }, [dynamicDefinitions, props.filterGroups, props.dynamicColumns, (_a = props.dynamicColumnsOptions) === null || _a === void 0 ? void 0 : _a.initialFilterValues]);
    const handleFilterApplied = (filter, sort) => {
        if (props.onFilterApplied) {
            props.onFilterApplied(filter);
        }
        appliedSort.current = sort;
        appliedFilters.current = filter;
    };
    const service = react_1.default.useMemo(() => mapService(props, new StorageClient_1.StorageClient(props.entity), filters, handleFilterApplied), [props.entity, props.storageClientFilter, filters, props.fullTextSearchField]);
    // service to simulate always loading, used to display loading bar until dynamic columns are loaded from network
    const fakeService = react_1.default.useMemo(() => {
        return {
            id: (row) => row.id,
            list: () => new Promise(() => undefined),
        };
    }, []);
    const columns = react_1.default.useMemo(() => {
        const returnValue = props.columns.map((column) => {
            var _a;
            return ({
                name: column.name,
                label: column.label,
                sortable: column.sortable,
                width: column.width,
                render: (_a = column.render) !== null && _a !== void 0 ? _a : ((row, column) => renderColumn(row, column)),
                sort: column.sort,
            });
        });
        if (props.dynamicColumns) {
            if ((dynamicDefinitions === null || dynamicDefinitions === void 0 ? void 0 : dynamicDefinitions.columnDefs) && dynamicDefinitions.handlerMap) {
                const dynamicColumns = dynamicDefinitions.columnDefs
                    .filter((columnDef) => { var _a; return (_a = columnDef.metadata) === null || _a === void 0 ? void 0 : _a.showInTable; })
                    .map((columnDef) => {
                    var _a, _b, _c;
                    const handlerWithData = dynamicDefinitions.handlerMap.get((_b = (_a = columnDef.metadata) === null || _a === void 0 ? void 0 : _a.columnHandlerName) !== null && _b !== void 0 ? _b : '');
                    return {
                        name: `_dynamic_${columnDef.name}`,
                        label: (_c = columnDef.metadata) === null || _c === void 0 ? void 0 : _c.label,
                        render: (row) => (0, dynamicColumns_1.formatDynamicColumnValue)(row, columnDef, handlerWithData),
                    };
                });
                returnValue.push(...dynamicColumns);
            }
            else {
                return [
                    {
                        name: 'loading',
                        label: 'Loading...',
                    },
                ];
            }
        }
        return returnValue;
    }, [props.columns, props.dynamicColumns, dynamicDefinitions]);
    const mobileColumns = react_1.default.useMemo(() => {
        if (props.mobileColumns) {
            const returnValue = props.mobileColumns.map((column) => {
                var _a;
                return ({
                    name: column.name,
                    label: column.label,
                    sortable: column.sortable,
                    width: column.width,
                    render: (_a = column.render) !== null && _a !== void 0 ? _a : renderColumn,
                    sort: column.sort,
                });
            });
            if (props.dynamicColumns) {
                if ((dynamicDefinitions === null || dynamicDefinitions === void 0 ? void 0 : dynamicDefinitions.columnDefs) && dynamicDefinitions.handlerMap) {
                    const dynamicColumns = dynamicDefinitions.columnDefs.filter((col) => { var _a; return (_a = col.metadata) === null || _a === void 0 ? void 0 : _a.showInTable; });
                    returnValue.push({
                        name: `_dynamic`,
                        label: 'Fields',
                        render: (row) => {
                            return dynamicColumns.map((columnDef) => {
                                var _a, _b, _c;
                                return (react_1.default.createElement("div", { key: columnDef.id },
                                    react_1.default.createElement(material_1.Typography, { color: 'textSecondary', component: 'span' }, (_a = columnDef.metadata) === null || _a === void 0 ? void 0 :
                                        _a.label,
                                        ":\u00A0"),
                                    (0, dynamicColumns_1.formatDynamicColumnValue)(row, columnDef, dynamicDefinitions.handlerMap.get((_c = (_b = columnDef.metadata) === null || _b === void 0 ? void 0 : _b.columnHandlerName) !== null && _c !== void 0 ? _c : ''))));
                            });
                        },
                    });
                }
                else {
                    return [
                        {
                            name: 'loading',
                            label: 'Loading...',
                        },
                    ];
                }
            }
            return returnValue;
        }
        else {
            return undefined;
        }
    }, [props.mobileColumns, props.dynamicColumns, dynamicDefinitions]);
    const toolbarActions = [];
    if (props.toolbarActions) {
        toolbarActions.push(...props.toolbarActions);
    }
    if (props.export) {
        toolbarActions.push({
            label: (_c = (_b = props.exportOptions) === null || _b === void 0 ? void 0 : _b.buttonLabel) !== null && _c !== void 0 ? _c : 'Export',
            actionProps: {
                startIcon: (_d = props.exportOptions) === null || _d === void 0 ? void 0 : _d.startIcon,
            },
            'data-test': 'export-button',
            onClick: () => {
                var _a;
                const onBeforeExport = ((_a = props.exportOptions) === null || _a === void 0 ? void 0 : _a.onBeforeExport) || Promise.resolve.bind(Promise);
                onBeforeExport()
                    .then(() => {
                    var _a;
                    return (0, entityExport_1.beginExport)(exportClient, props.entity, ((_a = props.exportOptions) === null || _a === void 0 ? void 0 : _a.exportType) || 'csv', props.multiSelectedRowIds, appliedFilters.current, appliedSort.current && mapSort(props, appliedSort.current));
                })
                    .catch(SnackbarHelper_1.handleErrorSnackbar);
            },
        });
    }
    if (props.import) {
        toolbarActions.push({
            label: (_f = (_e = props.importOptions) === null || _e === void 0 ? void 0 : _e.buttonLabel) !== null && _f !== void 0 ? _f : 'Import',
            actionProps: {
                startIcon: (_g = props.importOptions) === null || _g === void 0 ? void 0 : _g.startIcon,
            },
            'data-test': 'import-button',
            onClick: () => {
                (0, entity_import_1.showEntityImportDialog)({
                    entity: props.entity,
                    options: props.importOptions,
                });
            },
        });
    }
    return (react_1.default.createElement(DataTable_1.DataTable, { service: !dynamicDefinitions ? fakeService : service, columns: columns, mobileColumns: mobileColumns, initialSortColumnName: props.initialSortColumnName, initialSortColumnDesc: props.initialSortColumnDesc, filterGroups: filters, fullTextSearchField: props.fullTextSearchField, fullTextSearchInitialValue: props.fullTextSearchInitialValue, showFiltersInitially: props.showFiltersInitially, showFullTextSearchChipLabel: props.showFullTextSearchChipLabel, groupsCollapsed: props.groupsCollapsed, filterActionsComponent: props.filterActionsComponent, toolbarComponent: props.toolbarComponent, toolbarActions: toolbarActions, rowMenuItems: props.rowMenuItems, reloadFlag: props.reloadFlag, selectedRowId: props.selectedRowId, onSelectRow: props.onSelectRow, multiSelect: props.multiSelect, multiSelectedRowIds: props.multiSelectedRowIds, onMultiSelectChange: props.onMultiSelectChange, "data-test": props['data-test'] }));
}
exports.EntityTable = EntityTable;
function mapService(props, storageClient, filterGroups, onFilterApplied) {
    return {
        id: (row) => row.id,
        list: (filter, sort, limit, offset) => {
            const entityFilter = mapFilter(props, filter, filterGroups);
            if (onFilterApplied) {
                onFilterApplied(entityFilter, sort);
            }
            return storageClient.list({
                filter: entityFilter,
                orderBy: mapSort(props, sort),
                orderByUpdatedDesc: sort.length > 0 ? sort[0].desc : false,
                limit: limit,
                offset: offset,
            });
        },
    };
}
function mapFilter(props, filter, filterGroups) {
    var _a;
    let userFilter = [];
    filter.forEach((f) => {
        if (props.fullTextSearchField === f.field) {
            userFilter.push({
                column: f.field,
                op: mapFilterOp(props, f),
                value: f.value,
            });
        }
        else if (filterGroups) {
            for (const propsFilterGroup of filterGroups) {
                for (const propsFilterConfig of propsFilterGroup.configs) {
                    if (propsFilterConfig.field === f.field) {
                        if (propsFilterConfig.mapToFilter) {
                            const mappedFilters = propsFilterConfig.mapToFilter(filter);
                            (mappedFilters !== null && mappedFilters !== void 0 ? mappedFilters : []).forEach((mappedFilter) => userFilter.push(mappedFilter));
                        }
                        else {
                            userFilter.push({
                                column: f.field,
                                op: mapFilterOp(props, f),
                                value: f.value,
                            });
                        }
                    }
                }
            }
        }
        return undefined;
    });
    userFilter = userFilter.filter((f) => !!f);
    if ((_a = props.storageClientFilter) === null || _a === void 0 ? void 0 : _a.length) {
        // Filters from storageClientFilter must come first in this array.
        // Health Alerts rely on this implementation detail to implement group based filters.
        // Search for this code correlation id in health-alerts codebase to find the place:
        // code-correlation-id: e9f46c9f-bacc-49bc-9f59-37a0dcef5618
        return [...props.storageClientFilter, ...userFilter];
    }
    else {
        return userFilter;
    }
}
function mapFilterOp(props, filter) {
    if (filter.field === props.fullTextSearchField) {
        return 'full-text-query';
    }
    else if (filter.op) {
        return filter.op;
    }
    else if (Array.isArray(filter.value)) {
        return 'in';
    }
    else {
        return '=';
    }
}
function mapSort(props, sort) {
    let result = sort.map((s) => ({
        column: s.field,
        desc: s.desc,
    }));
    if (props.storageClientSort) {
        result = [...props.storageClientSort, ...result];
    }
    return result;
}
function renderColumn(row, column) {
    const value = row.columns[column.name];
    if (typeof value === 'boolean') {
        return react_1.default.createElement(react_1.default.Fragment, null, value ? 'true' : 'false');
    }
    else {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return react_1.default.createElement(material_1.Typography, { noWrap: true }, value);
    }
}
function EntityTableWithDetails(props) {
    const { details, onCloseDetails } = props, rest = __rest(props, ["details", "onCloseDetails"]);
    const storageClient = (0, hooks_1.useStorageClient)(props.entity);
    const loadSelectedRowData = (row) => {
        if (props.onSelectLoad) {
            props.onSelectLoad(row, () => {
                storageClient.get(row.id).then(props.onSelectData).catch(DialogHelper_1.handleErrorDialog);
            });
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(EntityTable, Object.assign({}, rest, { onSelectRow: loadSelectedRowData })),
        react_1.default.createElement(ModalSlideout_1.ModalSlideout, { open: !!details, onClose: () => onCloseDetails === null || onCloseDetails === void 0 ? void 0 : onCloseDetails(), "data-test": 'entity-table-with-details-slideout' }, details)));
}
exports.EntityTableWithDetails = EntityTableWithDetails;
